// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","brand_logo":"Navbar_brand_logo__GQtIn","btnSignIn":"Navbar_btnSignIn__BNoYN"};